import { render, staticRenderFns } from "./MyPasswordSent.vue?vue&type=template&id=4a63c7b0&scoped=true&"
import script from "./MyPasswordSent.vue?vue&type=script&lang=js&"
export * from "./MyPasswordSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63c7b0",
  null
  
)

export default component.exports